// Single frontend source for real estate packages. Mirrors backend/app/data/real_estate_packages.json
// (backend/tests/test_package_data_sync.py fails if the two files ever differ).
import data from '@/data/realEstatePackages.json';

export const PACKAGE_FEATURES = data.features;
export const INCLUDED_ADDON_KEYS = data.included_addon_keys;
export const PACKAGE_LIST = data.packages.map((p) => ({ ...p, price: p.price_cents / 100 }));
export const PACKAGES = Object.fromEntries(PACKAGE_LIST.map((p) => [p.code, p]));

const featureByKey = Object.fromEntries(PACKAGE_FEATURES.map((f) => [f.key, f]));

// Bullet list shown on pricing cards, /book cards, review and order pages.
export const packageIncludes = (pkg) => [
  pkg.size_item, `Up to ${pkg.photos} HDR photos`, ...pkg.features.map((k) => featureByKey[k].item),
];

// Labels for any stored package code, including legacy "custom_quote" on past orders.
export const packageLabel = (code) => PACKAGES[code]?.name || (code === 'custom_quote' ? 'Custom Quote' : code || '—');
export const packageLabelWithPrice = (code) => (PACKAGES[code] ? `${PACKAGES[code].name} ($${PACKAGES[code].price})` : packageLabel(code));
